import { formatNumber } from '@/assets'
import { useTranslation } from 'next-i18next'

const useDisplayDistance = () => {
  const { t } = useTranslation('common')

  const displayDistance = (distance?: number | string | null, prefix = '', maxPaddingDistance = 2) => {
    if (typeof distance === 'string') {
      return t('distanceFormat', { distance: `${prefix}${distance}` })
    }

    if (distance !== undefined && distance !== null) {
      let finalDistance = distance
      let padding = 0
      if (finalDistance < maxPaddingDistance) {
        padding = 1
      } else {
        finalDistance = Math.round(distance)
      }
      return t('distanceFormat', { distance: `${prefix}${formatNumber(Number(finalDistance), padding)}` })
    }
    return ''
  }

  return displayDistance
}

export default useDisplayDistance
